import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 px-4 bg-cream-dark/30" data-id="element-123">
      <div className="max-w-3xl mx-auto text-center" data-id="element-124">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white p-10 rounded-3xl shadow-warm border-2 border-brand-green/20 relative overflow-hidden" data-id="element-125">
          <div className="absolute -right-10 -top-10 text-brand-green/5" data-id="element-126">
            <ShieldCheck className="w-64 h-64" data-id="element-127" />
          </div>

          <div className="relative z-10" data-id="element-128">
            <ShieldCheck className="w-16 h-16 text-brand-green mx-auto mb-6" data-id="element-129" />
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-130">
              🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <p className="text-lg text-carbon mb-6 font-medium" data-id="element-131">
              Abrís los tomos. Probás las recetas. Calculás tus costos.
            </p>

            <p className="text-carbon-lighter mb-6 leading-relaxed" data-id="element-132">
              Si en 7 días no es lo que esperabas: devolución del 100% sin
              formularios, sin drama.
              <br data-id="element-133" />
              Escribinos a{' '}
              <a href="mailto:soportebibliodigital@gmail.com" className="text-brand-green hover:underline font-medium" data-id="element-134">
                soportebibliodigital@gmail.com
              </a>{' '}
              y listo.
            </p>

            <div className="inline-block bg-cream-light px-4 py-2 rounded-full text-sm text-carbon-lighter border border-cream-dark" data-id="element-135">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}